<template>
    <b-modal
        size="lg"
        v-model="modalShow"
        title="クーポン追加"
        @hidden="close">
        <form @submit.stop.prevent="addCoupon">
            <section class="mb-3">
                <h5 class="font-weight-bold">基本設定</h5>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label
                                for="name"
                                class="is-required-ja">
                                クーポン名
                            </label>
                            <input
                                v-model="coupon.name"
                                id="name"
                                class="form-control m-input"
                                :class="{ 'is-invalid' : errors.name }"
                                :disabled="inProgress"
                                type="text"
                                placeholder="クーポン名を入力してください">
                            <div
                                v-if="errors.name"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.name[0] }}
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label
                                for="campaign_name"
                                class="is-required-ja">
                                キャンペーン名
                            </label>
                            <input
                                v-model="coupon.campaign_name"
                                id="campaign_name"
                                class="form-control m-input"
                                :class="{ 'is-invalid' : errors.campaign_name }"
                                :disabled="inProgress"
                                type="text"
                                placeholder="キャンペーン名を入力してください">
                            <div
                                v-if="errors.campaign_name"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.campaign_name[0] }}
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label
                                for="category"
                                class="is-required-ja">
                                クーポンのタイプ
                            </label>
                            <select
                                v-model="coupon.category"
                                id="category"
                                class="form-control formMini"
                                :class="{ 'is-invalid' : errors.category }"
                                :disabled="inProgress">
                                <option :value="couponCategory.consultation">{{ $locale.consultation_host }}</option>
                                <option :value="couponCategory.plan">サービス</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label
                                for="discount"
                                class="is-required-ja">
                                割引方式
                            </label>
                            <select
                                v-model="coupon.discount_unit"
                                id="category"
                                class="form-control formMini"
                                :class="{ 'is-invalid' : errors.discount_unit }"
                                :disabled="inProgress">
                                <option v-if="coupon.category === couponCategory.consultation" value="static">固定金額</option>
                                <option v-if="coupon.category === couponCategory.plan" value="daily">日単位</option>
                            </select>
                            <div
                                v-if="errors.discount_unit"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.discount_unit[0] }}
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label
                                for="discount"
                                class="is-required-ja">
                                {{ labelDiscount }}
                            </label>
                            <input
                                v-model="coupon.discount"
                                id="discount"
                                class="form-control m-input formMini"
                                :class="{ 'is-invalid' : errors.discount }"
                                :disabled="inProgress"
                                type="number"
                                min="0"
                                :placeholder="placeholderDiscount">
                            <div
                                v-if="errors.discount"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.discount[0] }}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="mb-3">
                <h5 class="font-weight-bold">利用条件</h5>
                <div
                    v-if="coupon.category === couponCategory.consultation"
                    class="row">
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <div class="custom-control custom-checkbox">
                                <input
                                    v-model="coupon.is_only_matching"
                                    type="checkbox"
                                    id="is_only_matching"
                                    name="is_only_matching"
                                    class="custom-control-input"
                                    :disabled="inProgress">
                                <label
                                    class="custom-control-label"
                                    for="is_only_matching">
                                    マッチング予約のみ利用可能にする
                                </label>
                            </div>
                            <div
                                v-if="errors.is_only_matching"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.is_only_matching[0] }}
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label>対象医師</label>
                            <div class="d-flex align-items-center">
                                <div class="form-check mr-2">
                                    <input
                                        v-model="is_limit_doctor_id"
                                        :disabled="inProgress"
                                        value="0"
                                        type="radio"
                                        id="is_no_limit_doctor_id"
                                        name="is_no_limit_doctor_id"
                                        class="form-check-input">
                                    <label
                                        class="form-check-label"
                                        for="is_no_limit_doctor_id">
                                        制限なし
                                    </label>
                                </div>
                                <div class="form-check mr-2">
                                    <input
                                        v-model="is_limit_doctor_id"
                                        :disabled="inProgress"
                                        value="1"
                                        type="radio"
                                        id="is_limit_doctor_id"
                                        name="is_limit_doctor_id"
                                        class="form-check-input">
                                    <label
                                        class="form-check-label"
                                        for="is_limit_doctor_id">
                                        制限あり
                                    </label>
                                </div>
                            </div>
                            <div :class="{ 'd-none' : is_limit_doctor_id == '0' }">
                                <div v-for="(id, index) in coupon.doctor_ids">
                                    <div class="d-flex align-items-center mt-2">
                                        <select
                                            v-model="coupon.doctor_ids[index]"
                                            @change="updateDoctorMenuIdsList"
                                            :id="`doctor_id_${index}`"
                                            class="form-control"
                                            :class="{ 'is-invalid' : errors.doctor_id }"
                                            style="max-width: 380px;">
                                            <option :value="null">選択してください</option>
                                            <option
                                                v-for="doctor in filteredDoctors"
                                                :key="`doctor_id_${doctor.id}`"
                                                :value="doctor.id">
                                                {{ doctor.full_name }}
                                            </option>
                                        </select>
                                        <div
                                            v-if="coupon.doctor_ids.length > 1"
                                            @click="onClickRemoveSelectDoctor(index)"
                                            class="couponButton couponButtonRemove">
                                            -
                                        </div>
                                        <div
                                            v-if="coupon.doctor_ids.length === index + 1"
                                            @click="onClickAddSelectDoctor"
                                            class="couponButton couponButtonAdd">
                                            +
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="errors.doctor_id"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.doctor_id[0] }}
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label>対象メニュー</label>
                            <div class="d-flex align-items-center">
                                <div class="form-check mr-2">
                                    <input
                                        v-model="is_limit_doctor_menu_id"
                                        :disabled="inProgress"
                                        value="0"
                                        type="radio"
                                        id="is_no_limit_doctor_menu_id"
                                        name="is_no_limit_doctor_menu_id"
                                        class="form-check-input">
                                    <label
                                        class="form-check-label"
                                        for="is_no_limit_doctor_menu_id">
                                        制限なし
                                    </label>
                                </div>
                                <div class="form-check mr-2">
                                    <input
                                        v-model="is_limit_doctor_menu_id"
                                        :disabled="inProgress"
                                        value="1"
                                        type="radio"
                                        id="is_limit_doctor_menu_id"
                                        name="is_limit_doctor_menu_id"
                                        class="form-check-input">
                                    <label
                                        class="form-check-label"
                                        for="is_limit_doctor_menu_id">
                                        制限あり
                                    </label>
                                </div>
                            </div>
                            <div :class="{ 'd-none' : is_limit_doctor_menu_id == '0' }">
                                <div v-for="(id, index) in coupon.doctor_menu_ids">
                                    <div class="d-flex align-items-center mt-2">
                                        <select
                                            v-model="coupon.doctor_menu_ids[index]"
                                            :id="`doctor_menu_id_${index}`"
                                            class="form-control"
                                            :class="{ 'is-invalid' : errors.doctor_menu_id }"
                                            style="max-width: 380px;">
                                            <option :value="null">選択してください</option>
                                            <option
                                                v-for="doctorMenu in filteredDoctorMenus"
                                                :key="`doctor_menu_id_${doctorMenu.id}`"
                                                :value="doctorMenu.id">
                                                {{ doctorMenuFormat(doctorMenu) }}
                                            </option>
                                        </select>
                                        <div
                                            v-if="coupon.doctor_menu_ids.length > 1"
                                            @click="onClickRemoveSelectDoctorMenu(index)"
                                            class="couponButton couponButtonRemove">
                                            -
                                        </div>
                                        <div
                                            v-if="coupon.doctor_menu_ids.length === index + 1"
                                            @click="onClickAddSelectDoctorMenu"
                                            class="couponButton couponButtonAdd">
                                            +
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="errors.doctor_menu_id"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.doctor_menu_id[0] }}
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label>最低利用金額</label>
                            <div class="d-flex align-items-center">
                                <div class="form-check mr-2">
                                    <input
                                        v-model="is_limit_min_consultation_price"
                                        :disabled="inProgress"
                                        value="0"
                                        type="radio"
                                        id="is_no_limit_min_consultation_price"
                                        name="is_no_limit_min_consultation_price"
                                        class="form-check-input">
                                    <label
                                        class="form-check-label"
                                        for="is_no_limit_min_consultation_price">
                                        制限なし
                                    </label>
                                </div>
                                <div class="form-check mr-2">
                                    <input
                                        v-model="is_limit_min_consultation_price"
                                        :disabled="inProgress"
                                        value="1"
                                        type="radio"
                                        id="is_limit_min_consultation_price"
                                        name="is_limit_min_consultation_price"
                                        class="form-check-input">
                                    <label
                                        class="form-check-label"
                                        for="is_limit_min_consultation_price">
                                        制限あり
                                    </label>
                                </div>
                            </div>
                            <div :class="{ 'd-none' : is_limit_min_consultation_price == '0' }">
                                <div class="d-flex align-items-center">
                                    <input
                                        v-model="coupon.min_consultation_price"
                                        type="number"
                                        id="min_consultation_price"
                                        class="form-control m-input mt-2"
                                        :class="{ 'is-invalid' : errors.min_consultation_price }"
                                        style="max-width: 200px;">
                                    <span class="text-muted ml-2" style="position:relative; top:4px; width:90px;">円以上</span>
                                </div>
                            </div>
                            <div
                                v-if="errors.min_consultation_price"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.min_consultation_price[0] }}
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    v-else-if="couponCategory.plan"
                    class="row">
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label>対象サービスモデル</label>
                            <div class="d-flex align-items-center">
                                <div class="form-check mr-2">
                                    <input
                                        v-model="is_limit_plan_id"
                                        :disabled="inProgress"
                                        value="0"
                                        type="radio"
                                        id="is_no_limit_plan_id"
                                        name="is_no_limit_plan_id"
                                        class="form-check-input">
                                    <label
                                        class="form-check-label"
                                        for="is_no_limit_plan_id">
                                        制限なし
                                    </label>
                                </div>
                                <div class="form-check mr-2">
                                    <input
                                        v-model="is_limit_plan_id"
                                        :disabled="inProgress"
                                        value="1"
                                        type="radio"
                                        id="is_limit_plan_id"
                                        name="is_limit_plan_id"
                                        class="form-check-input">
                                    <label
                                        class="form-check-label"
                                        for="is_limit_plan_id">
                                        制限あり
                                    </label>
                                </div>
                            </div>
                            <div :class="{ 'd-none' : is_limit_plan_id == '0' }">
                                <div v-for="(id, index) in coupon.plan_ids">
                                    <div class="d-flex align-items-center mt-2">
                                        <select
                                            v-model="coupon.plan_ids[index]"
                                            :id="`plan_id_${index}`"
                                            class="form-control"
                                            :class="{ 'is-invalid' : errors.plan_id }"
                                            style="max-width: 380px;">
                                            <option :value="null">選択してください</option>
                                            <option
                                                v-for="plan in filteredPlans"
                                                :key="`plan_id_${plan.id}`"
                                                :value="plan.id">
                                                {{ plan.name }}
                                            </option>
                                        </select>
                                        <div
                                            v-if="coupon.plan_ids.length > 1"
                                            @click="onClickRemoveSelectPlan(index)"
                                            class="couponButton couponButtonRemove">
                                            -
                                        </div>
                                        <div
                                            v-if="coupon.plan_ids.length === index + 1"
                                            @click="onClickAddSelectPlan"
                                            class="couponButton couponButtonAdd">
                                            +
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="errors.plan_id"
                                class="invalid-feedback d-block mt-1">
                                {{ errors.plan_id[0] }}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="mb-3">
                <h5 class="font-weight-bold">取得条件</h5>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label class="is-required-ja">取得期限</label>

                            <div class="d-flex align-items-center mb-2">
                                <div class="form-check mr-2">
                                    <input
                                        v-model="is_get_based_on"
                                        :disabled="inProgress"
                                        value="date"
                                        type="radio"
                                        id="is_get_based_on_date"
                                        name="is_get_based_on_date"
                                        class="form-check-input">
                                    <label
                                        class="form-check-label"
                                        for="is_get_based_on_date">
                                        日付で指定
                                    </label>
                                </div>
                                <div class="form-check mr-2">
                                    <input
                                        v-model="is_get_based_on"
                                        :disabled="inProgress"
                                        value="days"
                                        type="radio"
                                        id="is_get_based_on_days"
                                        name="is_get_based_on_days"
                                        class="form-check-input">
                                    <label
                                        class="form-check-label"
                                        for="is_get_based_on_days">
                                        日数で指定
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input
                                        v-model="is_get_based_on"
                                        :disabled="inProgress"
                                        value="registration"
                                        type="radio"
                                        id="is_get_based_on_registration"
                                        name="is_get_based_on_registration"
                                        class="form-check-input">
                                    <label
                                        class="form-check-label"
                                        for="is_get_based_on_registration">
                                        {{ $locale.patient }}登録後の日数で指定
                                    </label>
                                </div>
                            </div>

                            <template v-if="is_get_based_on === 'date'">
                                <div class="d-flex align-items-center">
                                    <select
                                        v-model="coupon.get_expire_year"
                                        id="birth_year"
                                        style="max-width: 120px;"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.get_expire_day_at }">
                                        <option v-for="n in rangeYear" :key="n + yearBase" :value="n + yearBase">{{ n + yearBase }}</option>
                                    </select>
                                    <div class="text-muted ml-2 mr-2">年</div>
                                    <select
                                        v-model="coupon.get_expire_month"
                                        id="birth_month"
                                        style="max-width: 100px;"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.get_expire_day_at }">
                                        <option v-for="n in 12" :key="n" :value="n">{{ n }}</option>
                                    </select>
                                    <div class="text-muted ml-2 mr-2">月</div>
                                    <select
                                        v-model="coupon.get_expire_day"
                                        id="birth_day"
                                        style="max-width: 100px;"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.get_expire_day_at }">
                                        <option v-for="n in rangeDateGetExpireDay" :key="n" :value="n">{{ n }}</option>
                                    </select>
                                    <div class="text-muted ml-2">日</div>
                                </div>
                                <div
                                    v-if="errors.get_expire_day_at"
                                    class="invalid-feedback d-block mt-1">
                                    {{ errors.get_expire_day_at[0] }}
                                </div>
                            </template>
                            <template v-else-if="is_get_based_on === 'days'">
                                <div class="d-flex align-items-center">
                                    <span class="text-muted mr-2" style="width:45px;">発行後</span>
                                    <select
                                        v-model="coupon.get_expire_days"
                                        id="expire_days"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.get_expire_days }"
                                        style="max-width:180px;">
                                        <option :value="null">選択してください</option>
                                        <option v-for="n in 365" :key="n" :value="n">{{ n }}</option>
                                    </select>
                                    <span class="text-muted ml-2" style="width:40px;">日間</span>
                                </div>
                                <div
                                    v-if="errors.get_expire_days"
                                    class="invalid-feedback d-block mt-1">
                                    {{ errors.get_expire_days[0] }}
                                </div>
                            </template>
                            <template v-else-if="is_get_based_on === 'registration'">
                                <div class="d-flex align-items-center">
                                    <span class="text-muted mr-2" style="width:45px;">登録後</span>
                                    <select
                                        v-model="coupon.get_expire_registration_days"
                                        id="expire_days"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.get_expire_registration_days }"
                                        style="max-width:180px;">
                                        <option :value="null">選択してください</option>
                                        <option v-for="n in 365" :key="n" :value="n">{{ n }}</option>
                                    </select>
                                    <span class="text-muted ml-2">日以内</span>
                                </div>
                                <div
                                    v-if="errors.get_expire_registration_days"
                                    class="invalid-feedback d-block mt-1">
                                    {{ errors.get_expire_registration_days[0] }}
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </section>

            <section class="mb-3">
                <h5 class="font-weight-bold">失効条件</h5>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <label class="is-required-ja">失効タイミング</label>

                            <div class="d-flex align-items-center mb-2">
                                <div class="form-check mr-2">
                                    <input
                                        v-model="is_expire_based_on"
                                        :disabled="inProgress"
                                        value="date"
                                        type="radio"
                                        id="is_expire_based_on_date"
                                        name="is_expire_based_on_date"
                                        class="form-check-input">
                                    <label
                                        class="form-check-label"
                                        for="is_expire_based_on_date">
                                        日付で指定
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input
                                        v-model="is_expire_based_on"
                                        :disabled="inProgress"
                                        value="days"
                                        type="radio"
                                        id="is_expire_based_on_days"
                                        name="is_expire_based_on_days"
                                        class="form-check-input">
                                    <label
                                        class="form-check-label"
                                        for="is_expire_based_on_days">
                                        クーポン取得後の日数で指定
                                    </label>
                                </div>
                            </div>

                            <template v-if="is_expire_based_on === 'date'">
                                <div class="d-flex align-items-center">
                                    <select
                                        v-model="coupon.expire_year"
                                        id="birth_year"
                                        style="max-width: 120px;"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.expire_day_at }">
                                        <option v-for="n in rangeYear" :key="n + yearBase" :value="n + yearBase">{{ n + yearBase }}</option>
                                    </select>
                                    <div class="text-muted ml-2 mr-2">年</div>
                                    <select
                                        v-model="coupon.expire_month"
                                        id="birth_month"
                                        style="max-width: 100px;"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.expire_day_at }">
                                        <option v-for="n in 12" :key="n" :value="n">{{ n }}</option>
                                    </select>
                                    <div class="text-muted ml-2 mr-2">月</div>
                                    <select
                                        v-model="coupon.expire_day"
                                        id="birth_day"
                                        style="max-width: 100px;"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.expire_day_at }">
                                        <option v-for="n in rangeDateExpireDay" :key="n" :value="n">{{ n }}</option>
                                    </select>
                                    <div class="text-muted ml-2">日</div>
                                </div>
                                <div
                                    v-if="errors.expire_day_at"
                                    class="invalid-feedback d-block mt-1">
                                    {{ errors.expire_day_at[0] }}
                                </div>
                            </template>
                            <template v-else-if="is_expire_based_on === 'days'">
                                <div class="d-flex align-items-center">
                                    <span class="text-muted" style="width:58px;">取得後</span>
                                    <select
                                        v-model="coupon.expire_days"
                                        id="expire_days"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.expire_days }"
                                        style="max-width:180px;">
                                        <option :value="null">選択してください</option>
                                        <option v-for="n in 365" :key="n" :value="n">{{ n }}</option>
                                    </select>
                                    <span class="text-muted ml-2">日経過</span>
                                </div>
                                <div
                                    v-if="errors.expire_days"
                                    class="invalid-feedback d-block mt-1">
                                    {{ errors.expire_days[0] }}
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </section>

            <section class="mb-3">
                <h5 class="font-weight-bold">クーポンコードの設定</h5>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group m-form__group">
                            <div
                                v-for="(couponCode, index) in coupon.coupon_codes"
                                class="mb-3">
                                <div class="d-flex align-items-start mb-2">
                                    <div
                                        class="form-check mr-2 formCheckIsEnabled"
                                        :class="{ 'formCheckIsEnabledMarginTop' : index === 0 }">
                                        <input
                                            v-model="couponCode.is_enabled"
                                            value="1"
                                            type="checkbox"
                                            :id="`is_enabled_${index}`"
                                            :name="`is_enabled_${index}`"
                                            class="form-check-input">
                                        <label
                                            class="form-check-label"
                                            :for="`is_enabled_${index}`">
                                            有効
                                        </label>
                                    </div>
                                    <div class="mr-2">
                                        <label
                                            v-if="index === 0"
                                            class="is-required-ja">
                                            クーポンコード
                                        </label>
                                        <input
                                            v-model="couponCode.code"
                                            class="form-control m-input"
                                            :class="{ 'is-invalid' : errors[`coupon_codes.${index}.code`] }"
                                            style="max-width:256px;"
                                            type="text"
                                            placeholder="例）ABCD1234">
                                        <div
                                            v-if="errors[`coupon_codes.${index}.code`]"
                                            class="invalid-feedback d-block mt-1">
                                            {{ errors[`coupon_codes.${index}.code`][0] }}
                                        </div>
                                    </div>
                                    <div>
                                        <label v-if="index === 0">
                                            使用数上限
                                        </label>
                                        <input
                                            v-model="couponCode.use_limit"
                                            class="form-control m-input"
                                            :class="{ 'is-invalid' : errors[`coupon_codes.${index}.use_limit`] }"
                                            style="max-width:230px;"
                                            type="text"
                                            placeholder="例）100">
                                        <div
                                            v-if="errors[`coupon_codes.${index}.use_limit`]"
                                            class="invalid-feedback d-block mt-1">
                                            {{ errors[`coupon_codes.${index}.use_limit`][0] }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="coupon.coupon_codes.length > 1"
                                        @click="onClickRemoveCouponCode(index)"
                                        class="couponButton couponButtonRemove"
                                        :class="{ 'couponButtonMarginTop' : index === 0 }">
                                        -
                                    </div>
                                    <div
                                        v-if="coupon.coupon_codes.length === index + 1"
                                        @click="onClickAddCouponCode"
                                        class="couponButton couponButtonAdd"
                                        :class="{ 'couponButtonMarginTop' : index === 0 }">
                                        +
                                    </div>
                                </div>

                                <div class="couponCodeRemarksWrapper">
                                    <textarea
                                        v-model="couponCode.remarks"
                                        rows="1"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors[`coupon_codes.${index}.remarks`] }"
                                        placeholder="備考欄">
                                    </textarea>
                                    <div
                                        v-if="errors[`coupon_codes.${index}.remarks`]"
                                        class="invalid-feedback d-block mt-1">
                                        {{ errors[`coupon_codes.${index}.remarks`][0] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </form>

        <div
            slot="modal-footer"
            class="w-100" :class="{ 'u-loader u-loader--sm' : inProgress }">
            <button
                class="btn btn-yokumiru-orange float-right"
                style="width:90px;"
                :disabled="inProgress"
                @click="handleOk">
                追加
            </button>
        </div>
    </b-modal>
</template>

<script>
    import constants from '../../../constants'
    import moment from 'moment-timezone'

    export default {
        props: {
            doctors: {
                type: Array,
                required: true,
            },
            doctorMenus: {
                type: Array,
                required: true,
            },
            plans: {
                type: Array,
                required: true,
            },
        },

        data: function () {
            return {
                inProgress: false,
                modalShow: false,
                coupon: {
                    name: null,
                    campaign_name: null,
                    category: constants.couponCategory.consultation,
                    discount: null,
                    discount_unit: 'static',
                    get_expire_days: null,
                    get_expire_registration_days: null,
                    get_expire_year: moment().year(),
                    get_expire_month: 1,
                    get_expire_day: 1,
                    expire_days: null,
                    expire_year: moment().year(),
                    expire_month: 1,
                    expire_day: 1,
                    doctor_ids: [null],
                    doctor_menu_ids: [null],
                    plan_ids: [null],
                    coupon_codes: [{ code: null, use_limit: null, is_enabled: true, remarks: null }],
                    is_only_matching: false,
                },
                is_get_based_on: 'date',
                is_expire_based_on: 'date',
                is_limit_doctor_id: '0',
                is_limit_doctor_menu_id: '0',
                is_limit_min_consultation_price: '0',
                is_limit_plan_id: '0',
                yearBase: moment().subtract(1, 'years').year(),
                yearTo: moment().add(9, 'years').year(),
                doctorMenu: {},
                couponCategory: constants.couponCategory,
                errors: {},
            }
        },

        computed: {
            rangeYear: function () {
                return this.yearTo - this.yearBase
            },

            rangeDateGetExpireDay: function () {
                if (!this.coupon || !this.coupon.get_expire_year) {
                    return 1
                }

                const current = this.coupon.get_expire_year.toString() + '-' +
                    this.coupon.get_expire_month.toString().padStart(2, '0') + '-' + '01'

                return moment(current).endOf('month').date()
            },

            rangeDateExpireDay: function () {
                if (!this.coupon || !this.coupon.expire_year) {
                    return 1
                }

                const current = this.coupon.expire_year.toString() + '-' +
                    this.coupon.expire_month.toString().padStart(2, '0') + '-' + '01'

                return moment(current).endOf('month').date()
            },

            filteredDoctors: function () {
                return this.doctors.filter((doctor) => doctor.stopped_at === null)
            },

            filteredDoctorMenus: function () {
                const doctorIds = this.coupon.doctor_ids
                if (doctorIds.some((id) => id !== null)) {
                    return this.doctorMenus.filter((doctorMenu) => doctorIds.includes(doctorMenu.doctor_id))
                }
                return this.doctorMenus
            },

            filteredPlans: function () {
                return this.plans.filter((plan) => plan.plan_type !== constants.planTypes.free)
            },

            labelDiscount: function () {
                if (this.coupon.discount_unit === 'percent') {
                    return '割引率'
                }
                else if (this.coupon.discount_unit === 'static') {
                    return '割引額'
                }
                else if (this.coupon.discount_unit === 'daily') {
                    return '割引額（1日あたり）'
                }
                return ''
            },

            placeholderDiscount: function () {
                if (this.coupon.discount_unit === 'percent') {
                    return '割引率を入力してください'
                }
                else if (this.coupon.discount_unit === 'static') {
                    return '割引額を入力してください'
                }
                else if (this.coupon.discount_unit === 'daily') {
                    return '1日あたりの割引額を入力してください'
                }
                return ''
            },
        },

        watch: {
            /**
             * 取得条件（年）の変更検知用
             */
            'coupon.get_expire_year': function () {
                this.coupon = { ...this.coupon }

                const current = this.coupon.get_expire_year.toString() + '-' +
                    this.coupon.get_expire_month.toString().padStart(2, '0') + '-' +
                    this.coupon.get_expire_day.toString().padStart(2, '0')

                if (moment(current).format('YYYY-MM-DD') === 'Invalid date') {
                    const format = this.coupon.get_expire_year.toString() + '-' +
                        this.coupon.get_expire_month.toString().padStart(2, '0') + '-' + '01'

                    this.coupon.get_expire_day = moment(format).endOf('month').date()
                }
            },

            /**
             * 取得条件（月）の変更検知用
             */
            'coupon.get_expire_month': function () {
                this.coupon = { ...this.coupon }

                const current = this.coupon.get_expire_year.toString() + '-' +
                    this.coupon.get_expire_month.toString().padStart(2, '0') + '-' +
                    this.coupon.get_expire_day.toString().padStart(2, '0')

                if (moment(current).format('YYYY-MM-DD') === 'Invalid date') {
                    const format = this.coupon.get_expire_year.toString() + '-' +
                        this.coupon.get_expire_month.toString().padStart(2, '0') + '-' + '01'

                    this.coupon.get_expire_day = moment(format).endOf('month').date()
                }
            },

            /**
             * 失効条件（年）の変更検知用
             */
            'coupon.expire_year': function () {
                this.coupon = { ...this.coupon }

                const current = this.coupon.expire_year.toString() + '-' +
                    this.coupon.expire_month.toString().padStart(2, '0') + '-' +
                    this.coupon.expire_day.toString().padStart(2, '0')

                if (moment(current).format('YYYY-MM-DD') === 'Invalid date') {
                    const format = this.coupon.expire_year.toString() + '-' +
                        this.coupon.expire_month.toString().padStart(2, '0') + '-' + '01'

                    this.coupon.expire_day = moment(format).endOf('month').date()
                }
            },

            /**
             * 失効条件（月）の変更検知用
             */
            'coupon.expire_month': function () {
                this.coupon = { ...this.coupon }

                const current = this.coupon.expire_year.toString() + '-' +
                    this.coupon.expire_month.toString().padStart(2, '0') + '-' +
                    this.coupon.expire_day.toString().padStart(2, '0')

                if (moment(current).format('YYYY-MM-DD') === 'Invalid date') {
                    const format = this.coupon.expire_year.toString() + '-' +
                        this.coupon.expire_month.toString().padStart(2, '0') + '-' + '01'

                    this.coupon.expire_day = moment(format).endOf('month').date()
                }
            },

            /**
             * 対象医師の制限変更時
             * @param val
             */
            is_limit_doctor_id: function (val) {
                if (val === '0' || this.coupon.doctor_ids.length < 1) {
                    this.coupon.doctor_ids = [null]
                }
            },

            /**
             * 対象メニューの制限変更時
             * @param val
             */
            is_limit_doctor_menu_id: function (val) {
                if (val === '0' || this.coupon.doctor_menu_ids.length < 1) {
                    this.coupon.doctor_menu_ids = [null]
                }
            },

            /**
             * 最低利用金額の制限変更時
             * @param val
             */
            is_limit_min_consultation_price: function (val) {
                if (val === '0') {
                    this.coupon.min_consultation_price = null
                }
            },

            /**
             * 対象サービスモデルの制限変更時
             * @param val
             */
            is_limit_plan_id: function (val) {
                if (val === '0' || this.coupon.plan_ids.length < 1) {
                    this.coupon.plan_ids = [null]
                }
            },

            /**
             * クーポンのタイプ変更時
             * @param val
             */
            'coupon.category': function (val) {
                if (val === this.couponCategory.consultation) {
                    this.coupon.discount_unit = 'static'
                    this.coupon.plan_ids = [null]
                    this.is_limit_plan_id = '0'
                }
                else if (val === this.couponCategory.plan) {
                    this.coupon.discount_unit = 'daily'
                    this.coupon.doctor_ids = [null]
                    this.coupon.doctor_menu_ids = [null]
                    this.coupon.min_consultation_price = null
                    this.is_limit_doctor_id = '0'
                    this.is_limit_doctor_menu_id = '0'
                    this.is_limit_min_consultation_price = '0'
                }
            },
        },

        created: function () {
            bus.$on('open-modal-admin-add-coupon', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-admin-add-coupon')
        },

        methods: {
            /**
             * モーダル表示
             */
            open: function () {
                this.initCoupon()
                this.modalShow = true
            },

            /**
             * モーダルを閉じる
             */
            close: function () {
                this.modalShow = false
                this.errors = {}
            },

            /**
             * クーポンマスタ初期化
             */
            initCoupon: function () {
                this.coupon = {
                    name: null,
                    campaign_name: null,
                    category: constants.couponCategory.consultation,
                    discount: null,
                    discount_unit: 'static',
                    get_expire_days: null,
                    get_expire_registration_days: null,
                    get_expire_year: moment().year(),
                    get_expire_month: 1,
                    get_expire_day: 1,
                    expire_days: null,
                    expire_year: moment().year(),
                    expire_month: 1,
                    expire_day: 1,
                    doctor_ids: [null],
                    doctor_menu_ids: [null],
                    plan_ids: [null],
                    coupon_codes: [{ code: null, use_limit: null, is_enabled: true, remarks: null }],
                    is_only_matching: false,
                }
                this.is_get_based_on = 'date'
                this.is_expire_based_on = 'date'
                this.is_limit_doctor_id = '0'
                this.is_limit_doctor_menu_id = '0'
                this.is_limit_min_consultation_price = '0'
                this.is_limit_plan_id = '0'
            },

            /**
             * 制限医師の選択プルダウンを追加
             */
            onClickAddSelectDoctor: function () {
                this.coupon.doctor_ids.push(null)
            },

            /**
             * 制限医師の選択プルダウンを削除
             *
             * @param {number} index
             */
            onClickRemoveSelectDoctor: function (index) {
                this.coupon.doctor_ids.splice(index, 1)
                this.updateDoctorMenuIdsList()
            },

            /**
             * 制限医師メニューの選択プルダウンを追加
             */
            onClickAddSelectDoctorMenu: function () {
                this.coupon.doctor_menu_ids.push(null)
            },

            /**
             * 制限医師メニューの選択プルダウンを削除
             *
             * @param {number} index
             */
            onClickRemoveSelectDoctorMenu: function (index) {
                this.coupon.doctor_menu_ids.splice(index, 1)
            },

            /**
             * 制限サービスモデルの選択プルダウンを追加
             */
            onClickAddSelectPlan: function () {
                this.coupon.plan_ids.push(null)
            },

            /**
             * 制限サービスモデルの選択プルダウンを削除
             *
             * @param {number} index
             */
            onClickRemoveSelectPlan: function (index) {
                this.coupon.plan_ids.splice(index, 1)
            },

            /**
             * クーポンコードの入力行を追加
             */
            onClickAddCouponCode: function () {
                this.coupon.coupon_codes.push({ code: null, use_limit: null, is_enabled: true, remarks: null })
            },

            /**
             * クーポンコードの入力行を削除
             *
             * @param {number} index
             */
            onClickRemoveCouponCode: function (index) {
                this.coupon.coupon_codes.splice(index, 1)
            },

            /**
             * 制限医師に応じて医師メニューの選択状態をアップデート
             */
            updateDoctorMenuIdsList: function () {
                // 制限医師以外のメニューを取り除くためにインデックスを取得
                const removeIndexes = this.coupon.doctor_menu_ids.map((id, index) => {
                    if (id === null) return null

                    const doctorMenu = this.doctorMenus.find((doctorMenu) => doctorMenu.id === id)
                    if (this.coupon.doctor_ids.includes(doctorMenu.doctor_id)) {
                        return null
                    }
                    return index
                }).filter((v) => v !== null).sort().reverse()

                if (removeIndexes.length > 0) {
                    removeIndexes.forEach((index) => this.coupon.doctor_menu_ids.splice(index, 1))
                }

                // すべて取り除かれた場合
                if (this.coupon.doctor_menu_ids.length < 1) {
                    this.coupon.doctor_menu_ids.push(null)
                }
            },

            /**
             * 制限医師メニューのプルダウン用フォーマット
             *
             * @param {object} doctorMenu
             * @returns {string}
             */
            doctorMenuFormat: function (doctorMenu) {
                return `${doctorMenu.title}（${doctorMenu.doctor ? doctorMenu.doctor.full_name : '退会済の医師'}）`
            },

            handleOk(e) {
                e.preventDefault()
                this.addCoupon()
            },

            /**
             * クーポンマスタ追加
             */
            addCoupon: async function () {
                if (this.inProgress) return
                this.inProgress = true

                const params = { ...this.coupon }

                params.is_get_based_on = this.is_get_based_on
                params.get_expire_day_at = `${this.coupon.get_expire_year}-${this.coupon.get_expire_month.toString().padStart(2, '0')}-${this.coupon.get_expire_day.toString().padStart(2, '0')} 23:59:59`

                params.is_expire_based_on = this.is_expire_based_on
                params.expire_day_at = `${this.coupon.expire_year}-${this.coupon.expire_month.toString().padStart(2, '0')}-${this.coupon.expire_day.toString().padStart(2, '0')} 23:59:59`

                params.doctor_ids = params.doctor_ids.filter((v) => v !== null)
                params.doctor_menu_ids = params.doctor_menu_ids.filter((v) => v !== null)
                params.plan_ids = params.plan_ids.filter((v) => v !== null)
                params.coupon_codes = params.coupon_codes.filter((v) => v.code !== null)

                await axios.post(constants.admin.coupons.endpoint.base, params)
                    .then(() => {
                        bus.$emit('alert-success', 'クーポンを追加しました。')
                        bus.$emit('coupon-added')
                        this.errors = {}
                        this.initCoupon()
                        this.close()
                    })
                    .catch(({response}) => {
                        if (response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                            if (response.data.errors.hasOwnProperty('message')) {
                                bus.$emit('alert-danger', response.data.errors.message[0])
                            }
                            else {
                                bus.$emit('alert-danger')
                                this.errors = response.data.errors
                            }
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    });

                this.inProgress = false
            },
        },
    }
</script>

<style lang="scss" scoped>
.formMini {
    max-width: 290px;

    @media screen and (max-width:991px) {
        max-width: 100%;
    }
}

.couponCodeRemarksWrapper {
    max-width: 434px;
}

.couponButton {
    width: 37px;
    height: 37px;
    margin-left: 10px;
    line-height: 37px;
    color: #fff;
    font-weight: bold;
    text-align: center;
    background: #4E7DAB;
    border-radius: 5px;
    cursor: pointer;

    &.couponButtonRemove {
        color: #818181;
        background: #e8e8e8;
    }

    &.couponButtonMarginTop {
        margin-top: 31px;
    }
}

.formCheckIsEnabled {
    margin-top: 7px;

    &.formCheckIsEnabledMarginTop {
        margin-top: 38px;
    }

    input, label {
        cursor: pointer;
    }
}
</style>
